import { render, staticRenderFns } from "./AddNotarPro.vue?vue&type=template&id=507a916e"
import script from "./AddNotarPro.vue?vue&type=script&lang=js"
export * from "./AddNotarPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports